import { InternalAdvanceAccount } from '@varo/graphql-schema-types';
import { isPartiallyQualifiedAdvanceAccount } from 'features/advance/helpers/AdvanceProducts.helpers';
import GetAdvanceReEligibilityDetails from 'services/graphql/queries/FetchAdvanceReEligibility';
import useDefaultError from 'shared/hooks/errorFormatters/useDefaultError/useDefaultError';
import { logErrorWithContext } from 'shared/utils/sentry/sentry';
import {
  ErrorSeverity,
  FeatureArea,
  ResponsibleTeam,
} from 'shared/utils/sentry/sentry.constants';
import { useQuery } from 'urql';

export interface IAccountTypes {
  accountR2: InternalAdvanceAccount;
}

const useAdvanceReEligibility = (advanceAccountId: string | undefined) => {
  const [{ data, error, fetching }] = useQuery<IAccountTypes>({
    query: GetAdvanceReEligibilityDetails,
    pause: !advanceAccountId,
    variables: { id: advanceAccountId },
    requestPolicy: 'network-only',
  });

  const errorModel = useDefaultError();

  const accountDetails = isPartiallyQualifiedAdvanceAccount(data?.accountR2)
    ? data.accountR2
    : undefined;

  const advanceReeligibilityDetails = accountDetails?.reEligiblityDetail;
  const advanceTitle = advanceReeligibilityDetails?.title;
  const advanceDescription = advanceReeligibilityDetails?.description;

  if (
    !fetching &&
    (accountDetails === null ||
      accountDetails === undefined ||
      !advanceReeligibilityDetails)
  ) {
    logErrorWithContext(
      'Advance Partial Re-eligibility screen, re-eligibility data is null on accountR2',
      {
        featureArea: FeatureArea.LENDING,
        responsibleTeam: ResponsibleTeam.LENDING_CREDIT,
        severity: ErrorSeverity.LOW,
      },
    );
    return {
      advanceTitle: undefined,
      advanceDescription: undefined,
      loading: fetching,
      error: errorModel,
    };
  }

  return {
    advanceTitle,
    advanceDescription,
    loading: fetching,
    error: error ? errorModel : undefined,
  };
};

export default useAdvanceReEligibility;
